export default __webpack_public_path__ + "static/media/V460_CoC.09cce82a.pdf";